import { useMutation, useQuery } from "@tanstack/react-query";
import { oauthService } from "../services/oauthService";

export const oauthKeys = {
  all: ["oauth"] as const,
  authorization: (userId: string, authorizationId: string) => [...oauthKeys.all, userId, "authorization", authorizationId] as const,
  grants: (userId: string) => [...oauthKeys.all, userId, "grants"] as const,
};

export function useOAuthAuthorization(userId: string, authorizationId: string) {
  return useQuery({
    queryKey: oauthKeys.authorization(userId, authorizationId),
    queryFn: () => oauthService.getAuthorization(authorizationId, userId),
    retry: false,
    staleTime: Infinity,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });
}

export function useOAuthGrants(userId: string) {
  return useQuery({
    queryKey: oauthKeys.grants(userId),
    queryFn: async ({ signal }) => {
      const result = await oauthService.listGrants();
      signal.throwIfAborted();
      return result;
    },
    retry: false,
  });
}

export const useRevokeOAuthGrant = () => useMutation({ mutationFn: oauthService.revokeGrant });
